import {
  FkArrayBaseAttribute,
  type FkArrayBaseAttributeOptions,
} from './FkArrayBaseAttribute';
import {fkModel} from '../../../../models/hit/modelRegistry';

export class FkArrayStaffAttribute extends FkArrayBaseAttribute {
  constructor(options: FkArrayBaseAttributeOptions = {}) {
    super(options, fkModel('Staff'), fkModel('StaffList'));
  }
}
